import { configureStore } from './store';

export const { store, persistor } = configureStore();
